import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AppContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("q5_lang") || "es");
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("q5_cart") || "[]"); } catch { return []; }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [imageSlots, setImageSlots] = useState([]);

  useEffect(() => { localStorage.setItem("q5_lang", lang); }, [lang]);
  useEffect(() => { localStorage.setItem("q5_cart", JSON.stringify(cart)); }, [cart]);

  useEffect(() => {
    axios.get(`${API}/images`).then((r) => setImageSlots(r.data.slots || [])).catch(() => {});
  }, []);

  const hasImage = (slot) => imageSlots.includes(slot);

  const addToCart = (item) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.id === item.id);
      if (existing) {
        return prev.map((i) => i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i);
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  };

  const updateQty = (id, delta) => {
    setCart((prev) => prev
      .map((i) => i.id === id ? { ...i, quantity: i.quantity + delta } : i)
      .filter((i) => i.quantity > 0)
    );
  };

  const removeFromCart = (id) => setCart((prev) => prev.filter((i) => i.id !== id));
  const clearCart = () => setCart([]);

  const cartTotal = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const cartCount = cart.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <AppContext.Provider value={{
      lang, setLang,
      cart, addToCart, removeFromCart, updateQty, clearCart,
      cartTotal, cartCount,
      cartOpen, setCartOpen,
      imageSlots, hasImage,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
